/* eslint-disable spire/export-styles */
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker/DatePicker";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { useWORContext } from "@tKgpco/Widgets/WOR/WORCheckoutReviewSubmitPage";
import * as React from "react";
import { useEffect, useState } from "react";
import { css } from "styled-components";

export interface WORDeliveryDateStyles {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    dateGridItem?: GridItemProps;
    datePicker?: DatePickerPresentationProps;
    dateGridItemToDate?: GridItemProps;
}

export const worDeliveryDateStyles: WORDeliveryDateStyles = {
    gridContainer: {
        gap: 5,
        css: css`
            border-radius: 4px;
            padding: 10px;
            border: 2px solid #f1f6fb;
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    dateGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    dateGridItemToDate: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            margin-bottom: 2.5rem;
        `,
    },
};

const styles = worDeliveryDateStyles;

type Props = WidgetProps;

const WORDeliveryDates: React.FunctionComponent<Props> = ({ fields }: Props) => {
    const currentDay = new Date();

    const { worData, worDispatch } = useWORContext();


    // const changeDateFormatToString = (date: Date | undefined) => {
    //     if (!date) {
    //         return;
    //     }
    //     const yyyy = date.getFullYear();
    //     let mm: string | number = date.getMonth() + 1;
    //     let dd: string | number = date.getDate();

    //     if (dd < 10) {
    //         dd = `0${dd}`;
    //     }
    //     if (mm < 10) {
    //         mm = `0${mm}`;
    //     }

    //     return `${yyyy}/${mm}/${dd}`;
    // };

    const startDateChangeHandler = ({ selectedDay }: DatePickerState) => {
        worDispatch({
            type: "SET_REQUESTED_DELIVERY_DATE",
            payload: selectedDay,
        });
        if (selectedDay) {
            const earliestShipDate = new Date(new Date(selectedDay).getTime() + 86400000);
            setTimeout(() => {
                worDispatch({
                    type: "SET_DATA",
                    payload: {
                        earliestShipDate: convertDateToDateOnlyString(earliestShipDate),
                    },
                });
            }, 100);
        }
    };

    const toDateChangeHandler = ({ selectedDay }: DatePickerState) => {
        worDispatch({
            type: "SET_DATA",
            payload: {
                earliestShipDate: convertDateToDateOnlyString(selectedDay),
            },
        });
    };

    return (
        <WORDateRange
            requestedDelDate={worData.requestedDeliveryDate}
            earliestShipDate={undefined}
            minEarliestShipDate={worData.minEarliestShipDate}
            minRequestedDelDate={convertDateToDateOnlyString(currentDay)}
            reqDelDateChangeHandler={startDateChangeHandler}
            shipDateChangeHandler={toDateChangeHandler}
        />
    );
};

const WORDateRange = ({
    requestedDelDate,
    earliestShipDate,
    minEarliestShipDate,
    minRequestedDelDate,
    reqDelDateChangeHandler,
    shipDateChangeHandler,
}: any) => {
    return (
        <GridContainer
            css={css`
                margin-top: 1.5rem;
            `}
        >
            <GridItem {...styles.dateGridItem}>
                <DatePicker
                    {...styles.datePicker}
                    label={translate("Requested Delivery Date")}
                    selectedDay={convertDateOnlyStringToDate(requestedDelDate)}
                    onDayChange={reqDelDateChangeHandler}
                    dateTimePickerProps={{
                        clearIcon: null,
                        minDate: convertDateOnlyStringToDate(minRequestedDelDate),
                    }}
                    labelProps={{ size: 14 }}
                    required
                    error={!requestedDelDate ? translate(" Before submitting materials for release, the Requested Delivery Date must be populated") : ""}
                />
            </GridItem>
            <GridItem {...styles.dateGridItemToDate}>
                {earliestShipDate ? (
                    <DatePicker
                        {...styles.datePicker}
                        label={translate("Earliest Ship Date")}
                        selectedDay={convertDateOnlyStringToDate(earliestShipDate)}
                        onDayChange={shipDateChangeHandler}
                        dateTimePickerProps={{
                            clearIcon: null,
                            minDate: earliestShipDate ? convertDateOnlyStringToDate(minEarliestShipDate) : undefined,
                        }}
                        labelProps={{ size: 14 }}
                        required={!!earliestShipDate}
                    />
                ) : null}
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: WORDeliveryDates,
    definition: {
        displayName: "WOR Checkout Delivery Dates",
        group: "Checkout - Review & Submit",
    },
};

export default widgetModule;